interface ClientAdditionalInformation {
	name: string;
	value: string;
}

export interface ClientDetailsApi {
	client_id: string;
	client_secret: string;
	authorized_grant_types: string[];
	scopes: string[];
	additional_information: ClientAdditionalInformation[];
	refresh_token_validity: string;
	access_token_validity: string;
}

export enum ClientGrantStatus {
	ACTIVE = "ACTIVE",
	REVOKED = "REVOKED",
}

export interface ClientGrantApi {
	client_id: string;
	organization_id: number;
	organization_name: string;
	granted_scopes: string | string[];
	status: ClientGrantStatus;
	created_at: string;
	revoked_at?: string;
	id?: number;
}

export interface ClientDetailsImportContext {
	getClientDetails: (params?: Record<string, any>, options?: Record<string, any>) => Promise<ClientDetailsApi[]>;
	addClientDetail: (data: ClientDetailsApi) => Promise<ClientDetailsApi>;
	editClientDetail: (clientDetailId: string, data: ClientDetailsApi) => Promise<ClientDetailsApi>;
	deleteClientDetail: (clientDetailId: string) => Promise<{}>;
	getClientScopes: (params?: Record<string, any>, options?: Record<string, any>) => Promise<string[]>;
	getClientGrantTypes: (params?: Record<string, any>, options?: Record<string, any>) => Promise<string[]>;
	getClientSecret: (clientId: string, params?: Record<string, any>, options?: Record<string, any>) => Promise<string>;
	getAllClientGrants: (params?: Record<string, any>, options?: Record<string, any>) => Promise<ClientGrantApi[]>;
	getClientGrants: (
		clientId: string,
		params?: Record<string, any>,
		options?: Record<string, any>
	) => Promise<ClientGrantApi[]>;
	getClientGrant: (clientId: string, grantId: number, params?: Record<string, any>) => Promise<ClientGrantApi>;
	updateClientGrant: (
		clientId: string,
		data: ClientGrantApi,
		params?: Record<string, any>
	) => Promise<ClientGrantApi>;
	createClientGrant: (
		clientId: string,
		data: ClientGrantApi,
		params?: Record<string, any>
	) => Promise<ClientGrantApi>;
	revokeClientGrant: (clientId: string, grantId: number, params?: Record<string, any>) => Promise<ClientGrantApi>;
	activateClientGrant: (clientId: string, grantId: number, params?: Record<string, any>) => Promise<ClientGrantApi>;
	removeClientGrant: (clientId: string, grantId: number) => Promise<{}>;
}
